import { Skeleton } from '@mui/material';
import { Chain } from '@ankr.com/chains-list';

import { AddToProjectButton } from 'modules/chains/components/AddToProjectButton';
import { CodeExampleButton } from 'modules/chains/components/CodeExampleButton';
import { CopyEndpointModalWrapper } from 'modules/chains/components/CopyEndpointModal';
import { JWT } from 'domains/jwtToken/types';
import { Placeholder } from 'modules/common/components/Placeholder';
import { AddNetworkButton } from 'modules/wallet/components/AddNetworkButton';

import {
  IUseProjectActionsProps,
  useProjectActions,
} from './hooks/useProjectActions';
import { useProjectActionsStyles } from './useProjectActionsStyles';

export interface IProjectActionsProps extends IUseProjectActionsProps {
  isCurrentChainIncluded: boolean;
  jwts: JWT[];
  loading: boolean;
  projectWhitelistBlockchains: string[];
  chainForAddToProject: Chain;
}

export const ProjectActions = ({
  chain,
  chainForAddToProject,
  isCurrentChainIncluded,
  jwt,
  jwts,
  loading,
  projectWhitelistBlockchains,
}: IProjectActionsProps) => {
  const { classes } = useProjectActionsStyles();

  const { onCodeExampleModalOpen, projectChain, userEndpointToken } =
    useProjectActions({
      chain,
      jwt,
      projectWhitelistBlockchains,
    });

  if (loading) {
    return <Skeleton className={classes.skeleton} width={100} height={40} />;
  }

  return (
    <div className={classes.root}>
      <Placeholder
        hasPlaceholder={!isCurrentChainIncluded}
        placeholder={
          <AddToProjectButton chain={chainForAddToProject} size="small" />
        }
      >
        <CopyEndpointModalWrapper
          chain={projectChain}
          jwtTokens={jwts}
          userEndpointToken={userEndpointToken}
        />
        <CodeExampleButton
          chain={projectChain}
          onOpen={onCodeExampleModalOpen}
        />
        <AddNetworkButton
          hasAddNetworkDialog
          chain={projectChain}
          className={classes.addNetworkButton}
          size="small"
        />
      </Placeholder>
    </div>
  );
};
